import config from "flow/config";
import localStorageChannel from "flow/session/localStorageChannel";

export type CloseSubscriber = (guid: string) => void;

const messagesSeen: { [index: string]: boolean } = {};
const closeSubscribers: CloseSubscriber[] = [];
const dialogsShown: { [index: string]: boolean } = {};

export function setup() {
    localStorageChannel.subscribe(config.storageChannelTopics.systemInformationSeen, onMessagesSeenChanged);
    processMessagesSeen(localStorageChannel.getCurrentValue(config.storageChannelTopics.systemInformationSeen));
}

export function addCloseSubscriber(callback: CloseSubscriber) {
    closeSubscribers.push(callback);
}

export function removeCloseSubscriber(callback: CloseSubscriber) {
    const index = closeSubscribers.indexOf(callback);
    if (index >= 0) {
        closeSubscribers.splice(index, 1);
    }
}

function processMessagesSeen(messagesSeenString: string) {
    if (messagesSeenString) {
        messagesSeenString.split(";").forEach(guid => {
            if (!messagesSeen[guid]) {
                messagesSeen[guid] = true;
                notifySubscribers(guid);
            }
        });
    }
}

function notifySubscribers(guid: string) {
    closeSubscribers.slice().forEach(cs => cs(guid));
}

function onMessagesSeenChanged(messagesSeen: string) {
    processMessagesSeen(messagesSeen);
}

export function hasAlreadyBeenClosed(guid: string) {
    return !!messagesSeen[guid];
}

export function registerDialogAsShown(guid: string) {
    dialogsShown[guid] = true;
}

export function alreadyShownAsDialog(guid: string) {
    return dialogsShown[guid] === true;
}

export function closeInAllTabs(guid: string) {
    let currentStringList = localStorageChannel.getCurrentValue(config.storageChannelTopics.systemInformationSeen);
    if (currentStringList) {
        if (currentStringList.indexOf(guid) >= 0) {
            return;
        }
        currentStringList += ";" + guid;
    } else {
        currentStringList = guid;
    }

    localStorageChannel.publish(config.storageChannelTopics.systemInformationSeen, currentStringList);
}
